import { Table } from "@chakra-ui/react";
import { memo } from "react";
import { formatDocument } from "../../screenings/columns";
import {
  type IntegralCoverage,
  integralCoverageLabel,
} from "../integralCoverage";
import { formatCop } from "../format";
import type { PreApprovedScreening } from "../types";

type Props = {
  screening: PreApprovedScreening;
  integralCoverage: IntegralCoverage;
};

const SummaryRow = memo(({ screening, integralCoverage }: Props) => (
  <Table.Row>
    <Table.Cell>{formatDocument(screening)}</Table.Cell>
    <Table.Cell>{screening.tenantName}</Table.Cell>
    <Table.Cell>{screening.propertyAddress ?? "—"}</Table.Cell>
    <Table.Cell>{formatCop(screening.monthlyRent)}</Table.Cell>
    <Table.Cell>{integralCoverageLabel(integralCoverage)}</Table.Cell>
  </Table.Row>
));
SummaryRow.displayName = "SummaryRow";

export default SummaryRow;
